export var studentsByYear = [{
  year: 2020,
  students: [{
    name: "Oliver Cvetkovski",
    imageName: "oliver_cvetkovski.jpg",
    title: "Student at FCSE, Skopje"
  }, {
    name: "Kostadin Ljatkoski",
    imageName: "kostadin_ljatkoski.jpg",
    title: "Student at FCSE, Skopje"
  }, {
    name: "Bojan Jovanoski",
    imageName: "bojan_jovanoski.jpeg",
    title: "Student at FCSE, Skopje"
  }, {
    name: "Elena Karanfilovska",
    imageName: "elena_karanfilovska.jpg",
    title: "Student at FCSE, Skopje"
  }]
}, {
  year: 2018,
  students: [{
    name: "Aleksandar Bogevski",
    imageName: "avatar_male.svg",
    title: "Student at FCSE, Skopje"
  }, {
    name: "Jovan Davchev",
    imageName: "avatar_male.svg",
    title: "Student at FCSE, Skopje"
  }, {
    name: "Jordancho Arsov",
    imageName: "avatar_male.svg",
    title: "Student at FCSE, Skopje"
  }, {
    name: "Saso Najdov",
    imageName: "avatar_male.svg",
    title: "Student at FCSE, Skopje"
  }]
}, {
  year: 2017,
  students: [{
    name: "Angela Josifovska",
    imageName: "angela_josifovska.jpeg",
    title: "Student at FCSE, Skopje"
  }]
}, {
  year: 2016,
  students: [{
    name: "Simona Micevska",
    imageName: "simona_micevska.jpeg",
    title: "Student at FCSE, Skopje"
  }, {
    name: "Angela Davitkova",
    imageName: "avatar_female.svg",
    title: "Student at FCSE, Skopje"
  }, {
    name: "Damjan Gjurovski",
    imageName: "damjan_gjurovski.jpeg",
    title: "Student at FCSE, Skopje"
  }]
}];
export var professors = [{
  name: "Milos Jovanovik, Ph.D",
  imageName: "milos_jovanovik.jpeg",
  title: "Assistant Professor"
}, {
  name: "Kostadin Mishev, M.Sc.",
  imageName: "kostadin_mishev.jpg",
  title: "Teaching and Research Assistant"
}, {
  name: "Riste Stojanov, Ph.D",
  imageName: "riste_stojanov.jpg",
  title: "Assistant Professor"
}];